import {
  Button,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import * as React from "react";
import { useLanguage } from "./Language";
import LanguageIcon from "@mui/icons-material/Language";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CheckIcon from "@mui/icons-material/Check";

export interface LanguageInfo {
  code: string;
  displayName: string;
}

export interface AvailableLanguagesResponse {
  availableLanguages: LanguageInfo[];
}

export interface LanugageSelectorProps {}

export const LanguageSelector: React.FC<LanugageSelectorProps> = ({}) => {

  const theme = useTheme();
  const { translate, languageCode, changeLanguageCode, availableLanguages } = useLanguage();
  const fullSize = useMediaQuery(theme.breakpoints.up("sm"));
  const [languageAnchorEl, setLanguageAnchorEl] =
    React.useState<null | HTMLElement>(null);
  const languageOpen = Boolean(languageAnchorEl);
  const handleLanguageClick = (event: React.MouseEvent<HTMLElement>) => {
    setLanguageAnchorEl(event.currentTarget);
  };
  const handleLanguageClose = () => {
    setLanguageAnchorEl(null);
  };
  const handleLanguageSelection = (language: LanguageInfo) => {
    changeLanguageCode(language.code);
    handleLanguageClose();
  }

  const displayName = React.useMemo(() => {
    return (availableLanguages || []).find((language) => language.code === languageCode)?.displayName;
  }, [languageCode, availableLanguages]);

  return (
    <>
      {fullSize && (
        <Button
          color="inherit"
          aria-label={translate("readIn")}
          onClick={handleLanguageClick}
          aria-controls={languageOpen ? "language-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={languageOpen ? "true" : undefined}
          startIcon={<LanguageIcon />}
          endIcon={<ArrowDropDownIcon />}
        >
          {displayName}
        </Button>
      )}
      {!fullSize && (
        <IconButton
          aria-label={translate("readIn")}
          color="inherit"
          onClick={handleLanguageClick}
          aria-controls={languageOpen ? "language-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={languageOpen ? "true" : undefined}
        >
          <LanguageIcon />
        </IconButton>
      )}
      <Menu
        anchorEl={languageAnchorEl}
        id="langugage-menu"
        open={languageOpen}
        onClose={handleLanguageClose}
        onClick={handleLanguageClose}
      >
        {(availableLanguages || []).map((languageOption) => {
          return (
            <MenuItem key={languageOption.code} onClick={() => handleLanguageSelection(languageOption)}>
              <ListItemIcon>
                {languageCode === languageOption.code && <CheckIcon />}
              </ListItemIcon>
              <ListItemText>{languageOption.displayName}</ListItemText>
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};
